export const environment = {
  production: false,
  projectName: "AmeriDemo",
  dev: {
    REST_API_SERVER: "https://ameri.demo.api.testctsolution.it/api"
  },
  variables: {
    defaults: {}
  },
  customTranslationsDirectory: '/assets/custom-translations',
  defaultLang: 'it'
};
